module.exports = __webpack_public_path__ + "img/logo_vertical_branco.cb8016d7.svg";